import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js/instance/trim';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import * as React from 'react';
import { SEARCH_PAGE_PREFIX } from '../utils/index.js';
import { saveKeyword } from '../utils/history.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SuggestionList = /*#__PURE__*/function (_React$Component) {
  _inherits(SuggestionList, _React$Component);

  var _super = _createSuper(SuggestionList);

  function SuggestionList(props) {
    var _this;

    _classCallCheck(this, SuggestionList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleKeydown", function (e) {
      switch (e.key) {
        case 'Up': // IE/Edge specific value

        case 'ArrowUp':
          {
            e.preventDefault();

            _this.selectPrev();

            break;
          }

        case 'Down': // IE/Edge specific value

        case 'ArrowDown':
          {
            e.preventDefault();

            _this.selectNext();

            break;
          }

        case 'Enter':
          {
            var _this$state = _this.state,
                active = _this$state.active,
                keywordList = _this$state.keywordList;

            if (active === -1) {
              _this.props.hideSearchSuggestion();
            } else {
              saveKeyword(keywordList[active] || '');
            }

            break;
          }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "selectPrev", function () {
      var _this$containerRef, _this$containerRef$cu, _this$containerRef$cu2;

      var _this$state2 = _this.state,
          keywordList = _this$state2.keywordList,
          prev = _this$state2.active;
      var len = keywordList.length;
      var active = prev - 1 >= 0 ? prev - 1 : len - 1; // containerRef 是继承 SuggestionList 的组件内部 ref
      // 获取选中项 a 标签的焦点
      // TODO: 优化 children 的链

      var linkEl = (_this$containerRef = _this.containerRef) === null || _this$containerRef === void 0 ? void 0 : (_this$containerRef$cu = _this$containerRef.current) === null || _this$containerRef$cu === void 0 ? void 0 : (_this$containerRef$cu2 = _this$containerRef$cu.children) === null || _this$containerRef$cu2 === void 0 ? void 0 : _this$containerRef$cu2[active].querySelector('a');
      linkEl === null || linkEl === void 0 ? void 0 : linkEl.focus();

      _this.setState({
        active: active
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectNext", function () {
      var _this$containerRef2, _this$containerRef2$c, _this$containerRef2$c2;

      var _this$state3 = _this.state,
          keywordList = _this$state3.keywordList,
          prev = _this$state3.active;
      var len = keywordList.length;
      var active = prev + 1 >= len ? 0 : prev + 1; // 获取选中项 a 标签的焦点
      // TODO: 优化 children 的链

      var linkEl = (_this$containerRef2 = _this.containerRef) === null || _this$containerRef2 === void 0 ? void 0 : (_this$containerRef2$c = _this$containerRef2.current) === null || _this$containerRef2$c === void 0 ? void 0 : (_this$containerRef2$c2 = _this$containerRef2$c.children) === null || _this$containerRef2$c2 === void 0 ? void 0 : _this$containerRef2$c2[active].querySelector('a');
      linkEl === null || linkEl === void 0 ? void 0 : linkEl.focus();

      _this.setState({
        active: active
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (keyword) {
      var _context;

      var onSubmit = _this.props.onSubmit;
      var _this$state4 = _this.state,
          keywordList = _this$state4.keywordList,
          active = _this$state4.active;

      var searchKeyword = _trimInstanceProperty(_context = keyword || keywordList[active] || '').call(_context);

      var searchUrl = SuggestionList.getSearchLink(searchKeyword);
      saveKeyword(searchKeyword);

      if (onSubmit) {
        onSubmit(searchKeyword);
      } else {
        window.location.search = searchUrl;
      }

      _this.props.hideSearchSuggestion();
    });

    _this.state = {
      keywordList: [],
      // active 表示下拉框选项索引，默认值不选为 -1
      active: -1
    };
    return _this;
  }

  _createClass(SuggestionList, [{
    key: "addKeydownListener",
    value: function addKeydownListener() {
      var _this$props$searchFor, _this$props$searchFor2;

      (_this$props$searchFor = this.props.searchFormRef) === null || _this$props$searchFor === void 0 ? void 0 : (_this$props$searchFor2 = _this$props$searchFor.current) === null || _this$props$searchFor2 === void 0 ? void 0 : _this$props$searchFor2.addEventListener('keydown', this.handleKeydown, true);
    }
  }, {
    key: "removeKeydownListener",
    value: function removeKeydownListener() {
      var _this$props$searchFor3, _this$props$searchFor4;

      (_this$props$searchFor3 = this.props.searchFormRef) === null || _this$props$searchFor3 === void 0 ? void 0 : (_this$props$searchFor4 = _this$props$searchFor3.current) === null || _this$props$searchFor4 === void 0 ? void 0 : _this$props$searchFor4.removeEventListener('keydown', this.handleKeydown, true);
    }
  }], [{
    key: "getSearchLink",
    value: function getSearchLink(keyword) {
      var _context2;

      var searchPath = "".concat(SEARCH_PAGE_PREFIX, "?");

      var searchUrl = _concatInstanceProperty(_context2 = "".concat(searchPath, "s=")).call(_context2, encodeURIComponent(_trimInstanceProperty(keyword).call(keyword)));

      return searchUrl;
    }
  }]);

  return SuggestionList;
}(React.Component);

export { SuggestionList };
